import "../../styles/landing/Footer.css";

const Footer = () => {
  return (
    <>
      <div className="main4">
        <div>
          <div className="logo2">
            <img src="/image/logo.png" alt="Fotographiya Logo" />
          </div>
          <div className="ul-btn">
            <div className="listfooter">
              <ul className="ull">
                <a href="/" rel="noopener noreferrer">
                  <li>Home</li>
                </a>
                <li>Photographer Benefits</li>
                <a
                  href="https://www.fotographiya.com/aboutUs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <li>About Us</li>
                </a>
                <a
                  href="https://www.fotographiya.com/contactUs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <li>Contact Us</li>
                </a>

                <a
                  href="https://www.fotographiya.com/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <li>Blog</li>
                </a>
              </ul>
            </div>

            <div className="bttn">
              <a
                href="https://www.instagram.com/fotographiya_official/"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram @fotographiya_official"
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/e1306c/instagram-new.png"
                  alt="Instagram"
                />
              </a>

              <a
                href="https://www.facebook.com/people/Fotographiya-Wedphotography/100092454265642/"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook Fotographiya"
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/1877f2/facebook-new.png"
                  alt="Facebook"
                />
              </a>

              <a
                href="https://in.linkedin.com/in/mohit-barthunia"
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn Mohit Barthunia"
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/0a66c2/linkedin.png"
                  alt="LinkedIn"
                />
              </a>

              <a
                href="https://www.youtube.com/@Fotographiya_official"
                target="_blank"
                rel="noopener noreferrer"
                title="YouTube @Fotographiya_official"
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/ff0000/youtube-play.png"
                  alt="YouTube"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom Text */}
        <div className="footerbottom">
          <p className="leftside">© 2026 Fotographiya. All rights reserved.</p>
          <p className="rightside">
            <a href="https://www.fotographiya.com/privacy" target="_blank" rel="noopener noreferrer">Privacy policy</a> |
            <a href="https://www.fotographiya.com/terms" target="_blank" rel="noopener noreferrer">Terms & conditions</a> |
            <a href="https://www.fotographiya.com/contactUs" target="_blank" rel="noopener noreferrer">Support & Refunds</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
